import i18n from '@/utils/i18n';
import NoteIcon from '@assets/icons/note.svg';
import React from 'react';
import TrashIcon from '@assets/icons/trash-small.svg';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { ChatStatus } from '@/enums';
import { createStyles } from '@/contexts/theme-context';
import { EmployeeRestaurant } from '@/contexts/user-context';
import { Position } from '@/contexts/toast-context';
import { Text, TouchableOpacity, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';
import { useLayoutContext } from '@/contexts/layout-context';

interface Props {
  onClose: () => void;
  onOpenNoteActionSheet: () => void;
  onRemoveProspect: () => void;
  selectedRestaurant: EmployeeRestaurant;
}

export const MoreActionsActionSheet = ({
  onClose,
  onOpenNoteActionSheet,
  onRemoveProspect,
  selectedRestaurant,
}: Props) => {
  const [styles, theme] = useStyles();
  const { isSmallLayout } = useLayoutContext();
  return (
    <BaseActionSheet
      isVisible
      onClose={onClose}
      title={selectedRestaurant.name}
      toastPosition={Position.TOP}
    >
      <View style={styles.base}>
        {isSmallLayout ? (
          <Text numberOfLines={1} style={styles.titleTextStyle}>
            {selectedRestaurant.name}
          </Text>
        ) : null}
        {selectedRestaurant.showCrmActivities ? (
          <TouchableOpacity
            onPress={onOpenNoteActionSheet}
            style={[styles.row, styles.border]}
          >
            <NoteIcon height={24} stroke={theme.colors.primary} width={24} />
            <Text style={TYPOGRAPHY.pSemiBold}>{i18n.t('add_note')}</Text>
          </TouchableOpacity>
        ) : null}
        {selectedRestaurant.chatStatus === ChatStatus.PROSPECT ? (
          <TouchableOpacity
            onPress={onRemoveProspect}
            style={[styles.row, styles.border]}
          >
            <TrashIcon height={24} stroke={theme.colors.negative} width={24} />
            <Text style={styles.remove}>
              {i18n.t('remove_prospect.button')}
            </Text>
          </TouchableOpacity>
        ) : null}
      </View>
    </BaseActionSheet>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    paddingHorizontal: 12,
  },
  border: {
    borderBottomColor: theme.colors.background,
    borderBottomWidth: 1,
  },
  remove: {
    ...TYPOGRAPHY.pSemiBold,
    color: theme.colors.negative,
  },
  row: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 16,
    paddingVertical: 16,
  },
  titleTextStyle: {
    ...TYPOGRAPHY.h2,
    paddingBottom: 16,
  },
}));
